// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutMe_AboutMeDesktop__\\+NAyi {
  width: 60px;
  background-color: #0085FF;
  transition: width 0.5s ease-in-out;
  box-sizing: border-box;
  cursor: pointer;
}

.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 {
  width: calc(50vw - 180px);
  background-color: #0085FF;
  height: 100vh;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt {
  padding: 110px 71px 37px 66px;
  min-width: calc(50vw - 180px);
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_title__S4z7q {
  width: 100%;
  font-family: "Poppins", sans-serif;
  font-size: 48px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  margin-bottom: 43px;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_subTitle__1eLCR {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  border-bottom: 1px solid #000;
  padding-bottom: 16px;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_biography__Ggo82 {
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 150%;
  color: #140C0F;
  padding-top: 30px;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq {
  margin-top: 110px;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_detailsTitle__KsO9y {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  border-bottom: 1px solid #000;
  padding-bottom: 10px;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i {
  margin-top: 30px;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_title__S4z7q {
  font-family: "Inter", sans-serif;
  font-size: 24px;
  line-height: 150%;
  color: #191114;
  font-weight: 400;
  color: #140C0F;
  font-weight: 700;
  line-height: 110%;
  margin-bottom: 0px;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_featureTitle__7tebt {
  font-family: "Inter", sans-serif;
  font-size: 24px;
  line-height: 150%;
  color: #191114;
  font-weight: 400;
  color: #140C0F;
  font-weight: 700;
  line-height: 110%;
  margin-bottom: 0;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_text__tA4Af {
  margin-bottom: 50px;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 150%;
  color: #140C0F;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_link__HiIII {
  margin-bottom: 40px;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_link__HiIII > a {
  text-decoration: none;
  color: #140C0F;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_link__HiIII > a:hover {
  text-decoration: underline;
}
.AboutMe_tableDesktop__KNLmR .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_copyright__dRVNP {
  margin: 90px 0 30px;
}

.AboutMe_selectedDesktop__5K--S {
  cursor: default;
  width: calc(50vw - 180px);
}

.AboutMe_AboutMeTablet__EmAxf {
  background-color: #0085FF;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
}

.AboutMe_selectedTablet__oOS\\+V {
  cursor: default;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}

.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 {
  width: 100vw;
  background-color: #0085FF;
  height: 100vh;
  position: relative;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_closeIcon__zs8wa {
  position: fixed;
  right: 30px;
  top: 28px;
  z-index: 2;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt {
  padding: 112px 24px 30px 24px;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_title__S4z7q {
  width: 100%;
  font-family: "Poppins", sans-serif;
  font-size: 48px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  margin-bottom: 43px;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_subTitle__1eLCR {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  border-bottom: 1px solid #000;
  padding-bottom: 16px;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_biography__Ggo82 {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 150%;
  color: #140C0F;
  padding-top: 30px;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq {
  margin-top: 110px;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_detailsTitle__KsO9y {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  border-bottom: 1px solid #000;
  padding-bottom: 10px;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i {
  margin-top: 30px;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_title__S4z7q {
  font-family: "Inter", sans-serif;
  font-size: 24px;
  line-height: 150%;
  color: #191114;
  font-weight: 400;
  color: #140C0F;
  font-weight: 700;
  margin-bottom: 0;
  line-height: 150%;
  padding: 3px 0 10px;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_educationTitle__Vy2FJ {
  font-family: "Inter", sans-serif;
  font-size: 24px;
  line-height: 150%;
  color: #191114;
  font-weight: 400;
  color: #140C0F;
  font-weight: 700;
  margin-bottom: 0;
  line-height: 120%;
  padding: 3px 34px 10px 0;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_featureTitle__7tebt {
  font-family: "Inter", sans-serif;
  font-size: 24px;
  line-height: 150%;
  color: #191114;
  font-weight: 400;
  color: #140C0F;
  font-weight: 700;
  margin-bottom: 0;
  line-height: 120%;
  padding: 3px 0 10px;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_text__tA4Af {
  margin-bottom: 50px;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 150%;
  color: #140C0F;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_link__HiIII {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 40px;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_link__HiIII > a {
  text-decoration: none;
  color: #140C0F;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_detailsWrapper__NryUq .AboutMe_details__Jtx8i .AboutMe_link__HiIII > a:hover {
  text-decoration: underline;
}
.AboutMe_tableTablet__Bs58R .AboutMe_scrollBar__9leU6 .AboutMe_content__6n9xt .AboutMe_copyright__dRVNP {
  margin-top: 64px;
}`, "",{"version":3,"sources":["webpack://./src/tabs/AboutMe/AboutMe.module.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,WCFU;EDGV,yBCMQ;EDLR,kCC+Be;ED9Bf,sBAAA;EACA,eAAA;AADF;;AAKE;EACE,yBAAA;EACA,yBCHM;EDIN,aAAA;AAFJ;AAII;EACE,6BAAA;EACA,6BAAA;AAFN;AAIM;EACE,WAAA;EC2HN,kCAtGkB;EAuGlB,eA1Fa;EA2Fb,iBAtFe;EAuFf,cA7IgB;EA8IhB,gBAvGW;EDtBL,mBAAA;AAER;AACM;EC8GJ,kCA9FkB;EA+FlB,eAnFa;EAoFb,iBA9Ee;EA+Ef,cArIgB;EAsIhB,gBA/FW;EDjBL,6BAAA;EACA,oBAAA;AAKR;AAFM;ECoEJ,gCA3DiB;EA4DjB,eAlDa;EAmDb,iBA3Ce;EA4Cf,cAjGgB;ED4BV,iBAAA;AAOR;AAJM;EACE,iBAAA;AAMR;AAJQ;ECgGN,kCA9FkB;EA+FlB,eAnFa;EAoFb,iBA9Ee;EA+Ef,cArIgB;EAsIhB,gBA/FW;EDHH,6BAAA;EACA,oBAAA;AAUV;AAPQ;EACE,gBAAA;AASV;AAHU;ECqER,gCAjFiB;EAkFjB,eAtEa;EAuEb,iBAjEe;EAkEf,cAxHY;EAyHZ,gBAlFW;EAuFX,cA7HgB;EA8HhB,gBAvFW;EDUD,iBAAA;EACA,kBAAA;AAWZ;AARU;EC+DR,gCAjFiB;EAkFjB,eAtEa;EAuEb,iBAjEe;EAkEf,cAxHY;EAyHZ,gBAlFW;EAuFX,cA7HgB;EA8HhB,gBAvFW;EDgBD,iBAAA;EACA,gBAAA;AAgBZ;AAbU;EACE,mBAAA;ECkCV,gCA3DiB;EA4DjB,eAlDa;EAmDb,iBA3Ce;EA4Cf,cAjGgB;AD+ElB;AAfU;EACE,mBAAA;AAiBZ;AAfY;EACE,qBAAA;EACA,cCrEI;ADsFlB;AAfc;EACE,0BAAA;AAiBhB;AATM;EACE,mBAAA;AAWR;;AAJA;EACE,eAAA;EACA,yBAAA;AAOF;;AAJA;EACE,yBC1FQ;ED2FR,WAAA;EACA,sBAAA;EACA,eAAA;AAOF;;AAJA;EACE,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;AAOF;;AADE;EACE,YAAA;EACA,yBC9GM;ED+GN,aAAA;EACA,kBAAA;AAIJ;AAFE;EC/FA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;ADoGF;AAJI;EACE,6BChHsB;ADsH5B;AAJM;EACE,WAAA;ECYN,kCAtGkB;EAuGlB,eA1Fa;EA2Fb,iBAtFe;EAuFf,cA7IgB;EA8IhB,gBAvGW;EDyFL,mBAAA;AAUR;AAPM;ECDJ,kCA9FkB;EA+FlB,eAnFa;EAoFb,iBA9Ee;EA+Ef,cArIgB;EAsIhB,gBA/FW;ED8FL,6BAAA;EACA,oBAAA;AAaR;AAVM;EClDJ,gCApDiB;EAqDjB,eA5Ca;EA6Cb,iBApCe;EAqCf,cA1FgB;ED2IV,iBAAA;AAeR;AAZM;EACE,iBAAA;AAcR;AAZQ;ECfN,kCA9FkB;EA+FlB,eAnFa;EAoFb,iBA9Ee;EA+Ef,cArIgB;EAsIhB,gBA/FW;ED4GH,6BAAA;EACA,oBAAA;AAkBV;AAfQ;EACE,gBAAA;AAiBV;AAXU;EC1CR,gCAjFiB;EAkFjB,eAtEa;EAuEb,iBAjEe;EAkEf,cAxHY;EAyHZ,gBAlFW;EAuFX,cA7HgB;EA8HhB,gBAvFW;EDyHD,gBAAA;EACA,iBAAA;EACA,mBAAA;AAmBZ;AAhBU;ECjDR,gCAjFiB;EAkFjB,eAtEa;EAuEb,iBAjEe;EAkEf,cAxHY;EAyHZ,gBAlFW;EAuFX,cA7HgB;EA8HhB,gBAvFW;EDgID,gBAAA;EACA,iBAAA;EACA,wBAAA;AAwBZ;AArBU;ECxDR,gCAjFiB;EAkFjB,eAtEa;EAuEb,iBAjEe;EAkEf,cAxHY;EAyHZ,gBAlFW;EAuFX,cA7HgB;EA8HhB,gBAvFW;EDuID,gBAAA;EACA,iBAAA;EACA,mBAAA;AA6BZ;AA1BU;EACE,mBAAA;ECtFV,gCA3DiB;EA4DjB,eAlDa;EAmDb,iBA3Ce;EA4Cf,cAjGgB;ADoNlB;AA5BU;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EAEA,mBAAA;AA6BZ;AA3BY;EACE,qBAAA;EACA,cClMI;AD+NlB;AA3Bc;EACE,0BAAA;AA6BhB;AArBM;EACE,gBAAA;AAuBR","sourcesContent":["@import \"src/styles/variables\";\n\n.AboutMeDesktop {\n  width: $tab-width;\n  background-color: $aboutUs;\n  transition: $tab-transition;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n.tableDesktop {\n  .scrollBar {\n    width: calc(50vw - 180px);\n    background-color: $aboutUs;\n    height: 100vh;\n\n    .content {\n      padding: 110px 71px 37px 66px;\n      min-width: calc(50vw - 180px);\n\n      .title {\n        width: 100%;\n        @include font-title-48;\n        margin-bottom: 43px;\n      }\n\n      .subTitle {\n        @include font-title-32;\n        border-bottom: 1px solid #000;\n        padding-bottom: 16px;\n      }\n\n      .biography {\n        @include font-20;\n        padding-top: 30px;\n      }\n\n      .detailsWrapper {\n        margin-top: 110px;\n\n        .detailsTitle {\n          @include font-title-32;\n          border-bottom: 1px solid #000;\n          padding-bottom: 10px;\n        }\n\n        .details {\n          margin-top: 30px;\n\n          .upperTitle {\n\n          }\n\n          .title {\n            @include font-24-bold;\n            line-height: 110%;\n            margin-bottom: 0px;\n          }\n\n          .featureTitle {\n            @include font-24-bold;\n            line-height: 110%;\n            margin-bottom: 0;\n          }\n\n          .text {\n            margin-bottom: 50px;\n            @include font-20;\n          }\n\n          .link {\n            margin-bottom: 40px;\n\n            & > a {\n              text-decoration: none;\n              color: $sub-title-color;\n\n              &:hover {\n                text-decoration: underline;\n              }\n            }\n          }\n\n        }\n      }\n\n      .copyright {\n        margin: 90px 0 30px;\n      }\n    }\n  }\n}\n\n\n.selectedDesktop {\n  cursor: default;\n  width: calc(50vw - #{$not-active-tabs-width});\n}\n\n.AboutMeTablet {\n  background-color: $aboutUs;\n  width: 100%;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n.selectedTablet {\n  cursor: default;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n\n.tableTablet {\n    //position: relative;\n\n  .scrollBar {\n    width: 100vw;\n    background-color: $aboutUs;\n    height: 100vh;\n    position: relative;\n\n  .closeIcon {\n    @include closeIcon;\n  }\n\n    .content {\n      padding: $mobile-tab-tablet-padding;\n\n      .title {\n        width: 100%;\n        @include font-title-48;\n        margin-bottom: 43px;\n      }\n\n      .subTitle {\n        @include font-title-32;\n        border-bottom: 1px solid #000;\n        padding-bottom: 16px;\n      }\n\n      .biography {\n        @include font-18;\n        padding-top: 30px;\n      }\n\n      .detailsWrapper {\n        margin-top: 110px;\n\n        .detailsTitle {\n          @include font-title-32;\n          border-bottom: 1px solid #000;\n          padding-bottom: 10px;\n        }\n\n        .details {\n          margin-top: 30px;\n\n          .upperTitle {\n\n          }\n\n          .title {\n            @include font-24-bold;\n            margin-bottom: 0;\n            line-height: 150%;\n            padding: 3px 0 10px;\n          }\n\n          .educationTitle {\n            @include font-24-bold;\n            margin-bottom: 0;\n            line-height: 120%;\n            padding: 3px 34px 10px 0;\n          }\n\n          .featureTitle {\n            @include font-24-bold;\n            margin-bottom: 0;\n            line-height: 120%;\n            padding: 3px 0 10px;\n          }\n\n          .text {\n            margin-bottom: 50px;\n            @include font-20;\n          }\n\n          .link {\n            max-width: 90%;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n\n            margin-bottom: 40px;\n\n            & > a {\n              text-decoration: none;\n              color: $sub-title-color;\n\n              &:hover {\n                text-decoration: underline;\n              }\n            }\n          }\n\n        }\n      }\n\n      .copyright {\n        margin-top: 64px;\n      }\n    }\n  }\n}","//tab sizes\n$tab-width: 60px;\n$not-active-tabs-width: 180px;\n\n//fonts colors\n$title-color: #191114;\n$sub-title-color: #140C0F;\n$footer-color: #323433;\n\n//tabs colors\n$aboutUs: #0085FF;\n$Business: #69B4FF;\n$News: #E0FFFF;\n$Contact: #70E072;\n$MessageSent: #A5F2A6;\n\n//def padding\n$mobile-tab-tablet-padding: 112px 24px 30px 24px;\n\n//def tab content styles\n@mixin selectedTablet {\n  cursor: default;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n@mixin closeIcon {\n  position: fixed;\n  right: 30px;\n  top: 28px;\n  z-index: 2;\n}\n\n//transitions\n$tab-transition: width .5s ease-in-out;\n$left-content-transition-1: opacity .7s ease-in-out;\n$left-content-transition-2: opacity 3s ease-in-out;\n\n//fonts values\n$font-family-main: 'Inter', sans-serif;\n$font-family-title: 'Poppins', sans-serif;\n\n$font-w-400: 400;\n$font-w-700: 700;\n\n$font-size-13: 13px;\n$font-size-14: 14px;\n$font-size-16: 16px; //150%\n$font-size-18: 18px; //150%\n$font-size-20: 20px; // 150%\n$font-size-22: 22px;\n$font-size-24: 24px; //150%\n$font-size-32: 32px; //100%\n$font-size-48: 48px; //80%\n\n$font-size-179: 179px; //80%\n\n$font-line-150p: 150%;\n$font-line-100p: 100%;\n$font-line-80p: 80%;\n\n//font variants\n@mixin font-title-179 {\n  font-family: $font-family-title;\n  font-size: $font-size-179;\n  line-height: $font-line-80p;\n  font-weight: $font-w-700;\n}\n\n@mixin font-13 {\n  font-family: $font-family-main;\n  font-size: $font-size-13;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-14 {\n  font-family: $font-family-main;\n  font-size: $font-size-14;\n  line-height: 16px;\n  color: $sub-title-color;\n}\n\n@mixin font-16 {\n  font-family: $font-family-main;\n  font-size: $font-size-16;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-18 {\n  font-family: $font-family-main;\n  font-size: $font-size-18;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20 {\n  font-family: $font-family-main;\n  font-size: $font-size-20;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20-title {\n  font-family: $font-family-title;\n  font-size: $font-size-20;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-22 {\n  font-family: $font-family-title;\n  font-size: $font-size-22;\n  line-height: $font-line-80p;\n  color: $sub-title-color;\n}\n\n@mixin font-24 {\n  font-family: $font-family-main;\n  font-size: $font-size-24;\n  line-height: $font-line-150p;\n  color: $title-color;\n  font-weight: $font-w-400;\n}\n\n@mixin font-24-bold {\n  @include font-24;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-32 {\n  font-family: $font-family-title;\n  font-size: $font-size-32;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-48 {\n  font-family: $font-family-title;\n  font-size: $font-size-48;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AboutMeDesktop": `AboutMe_AboutMeDesktop__+NAyi`,
	"tableDesktop": `AboutMe_tableDesktop__KNLmR`,
	"scrollBar": `AboutMe_scrollBar__9leU6`,
	"content": `AboutMe_content__6n9xt`,
	"title": `AboutMe_title__S4z7q`,
	"subTitle": `AboutMe_subTitle__1eLCR`,
	"biography": `AboutMe_biography__Ggo82`,
	"detailsWrapper": `AboutMe_detailsWrapper__NryUq`,
	"detailsTitle": `AboutMe_detailsTitle__KsO9y`,
	"details": `AboutMe_details__Jtx8i`,
	"featureTitle": `AboutMe_featureTitle__7tebt`,
	"text": `AboutMe_text__tA4Af`,
	"link": `AboutMe_link__HiIII`,
	"copyright": `AboutMe_copyright__dRVNP`,
	"selectedDesktop": `AboutMe_selectedDesktop__5K--S`,
	"AboutMeTablet": `AboutMe_AboutMeTablet__EmAxf`,
	"selectedTablet": `AboutMe_selectedTablet__oOS+V`,
	"tableTablet": `AboutMe_tableTablet__Bs58R`,
	"closeIcon": `AboutMe_closeIcon__zs8wa`,
	"educationTitle": `AboutMe_educationTitle__Vy2FJ`
};
export default ___CSS_LOADER_EXPORT___;
